module.exports = __webpack_public_path__ + "static/img/bg_xiadan@2x (1)(1).7387b6cd.png";